// extracted by mini-css-extract-plugin
export default {"item":"DiffItem_item__aC5AO","num":"DiffItem_num__CbDfR","body":"DiffItem_body__iPPjW"};